<style scope>
</style>

<template>
  <section class="container">

    <portal-box style="min-height: 600px">
      <h1 slot="titulo" class="title">{{ (codigoCliente) ? 'Títulos em Aberto' : 'Títulos' }}</h1>

      <template slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading" v-if="!codigoCliente">

          <b-field label="Status">
            <b-select v-model="filtro.status" placeholder="status">
              <option selected :value="'todos'" :key="'todos'">Todos</option>
              <option :value="'aberto'" :key="'aberto'">Em aberto</option>
              <option :value="'aberto_vencido'" :key="'aberto_vencido'">Em aberto vencido</option>
              <option :value="'aberto_a_vencer'" :key="'aberto_a_vencer'">Em aberto a vencer</option>
              <option :value="'pago'" :key="'pago'">Pago</option>
            </b-select>
          </b-field>

          <b-field label="Cliente código">
            <b-input v-model="filtro.clienteCodigo" placeholder="código do cliente"/>
          </b-field>

          <b-field label="Cliente nome">
            <b-input v-model="filtro.clienteNome" placeholder="Razão ou fantasia"/>
          </b-field>

          <b-field label="Código do pedido">
            <b-input v-model="filtro.pedidoParam" placeholder="código do pedido"/>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="Início" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Vencimento</label>
          <b-field>
            <b-datepicker placeholder="Início" v-model="filtro.vencimentoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.vencimentoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.vencimentoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()" v-if="!codigoCliente">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Qtd. Total: {{lista.length}}</b-tag>
        <b-tag v-if="codigoCliente" class="is-medium is-primary" style="height: 100%">Valor Total: {{valorTotalTitulos | moeda}}</b-tag>
      </template>

      <b-table :data="lista" :loading="loading" class="row-click"
               :paginated="!codigoCliente">
        <portal-lista-vazia slot="empty"/>

        <template slot-scope="props">

          <b-table-column label="Pedido">
            {{ props.row.E1_PEDIDO }}
          </b-table-column>

          <b-table-column label="Prefixo">
            {{ props.row.E1_PREFIXO }}
          </b-table-column>

          <b-table-column label="Nº título">
          {{ props.row.E1_NUM }}
          </b-table-column>

          <b-table-column label="Parcela">
            {{ props.row.E1_PARCELA }}
          </b-table-column>

          <b-table-column label="Cliente">
            {{ props.row.E1_CLIENTE }}
          </b-table-column>

          <b-table-column label="Nome do cliente">
            {{ props.row.A1_NOME }}
          </b-table-column>

          <b-table-column label="Emissão">
            {{ props.row.E1_EMISSAO | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Vencimento">
            {{ props.row.E1_VENCREA | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Valor">
            {{ props.row.E1_VALOR | moeda }}
          </b-table-column>

          <b-table-column label="Baixa">
            {{ (props.row.E1_BAIXA === '0000-00-00') ? ' - ' : props.row.E1_BAIXA | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Saldo">
            {{ props.row.E1_SALDO | moeda }}
          </b-table-column>


          <b-table-column label="">
          </b-table-column>
        </template>

      </b-table>

    </portal-box>
  </section>
</template>

<script>
  import { auth } from '../../mixins/auth'
  import { listagem } from '../../mixins/listagem'

  export default {
    props: ['codigoCliente'],
    mixins: [auth, listagem],
    created () {
      this.url = this.$URL.TITULO
      this.metodo = 'PUT'
      if (this.codigoCliente) {
        this.filtro.clienteCodigo = this.codigoCliente
        this.filtro.status = 'aberto_vencido'
      }
    },
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/titulo').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    computed: {
      valorTotalTitulos () {
        let valor = 0
        if (this.lista.length > 0) {
          this.lista.forEach(c => {
            valor = valor + parseFloat(c.E1_SALDO)
          })
        }
        return parseFloat(valor).toFixed(2)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/titulo/Lista.vue